function isEmptyOrWhitespace(value){
    var str = value.toString()

    return str === null || str.trim() === "";
}

function isNumber(value) {
    return /^\d+$/.test(value);
}

function isPhoneNumber(value) {
    return isNumber(value) && value.toString().length == 11
}

export {
    isEmptyOrWhitespace,
    isNumber,
    isPhoneNumber
}
